// package: report
// file: apigateway/report/violation.proto

import * as apigateway_report_violation_pb from "../../apigateway/report/violation_pb";
export class ViolationService {
  static serviceName = "report.ViolationService";
}
export namespace ViolationService {
  export class GetReasons {
    static readonly methodName = "GetReasons";
    static readonly service = ViolationService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_report_violation_pb.GetReasonsRequest;
    static readonly responseType = apigateway_report_violation_pb.GetReasonsReply;
  }
  export class AddReport {
    static readonly methodName = "AddReport";
    static readonly service = ViolationService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_report_violation_pb.AddReportRequest;
    static readonly responseType = apigateway_report_violation_pb.AddReportReply;
  }
}
